import { render } from "./Aviso.vue?vue&type=template&id=1246e836&scoped=true"
import script from "./Aviso.vue?vue&type=script&lang=js"
export * from "./Aviso.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=1246e836&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1246e836"]])

export default __exports__